export interface IFooterButton {
    text: string;
    action: string;
    section: ButtonSection;
    icon?: string;
    link?: string;
    cssClass?: string;
    type?: string;
    disabled?: boolean;
    tooltip?: string;
    stylingMode?: string;
}

export enum ButtonSection {
    Left = 'before',
    Center = 'center',
    Right = 'after',
}
